module.exports = __webpack_public_path__ + "img/clear.fd3be0a2.svg";